module.exports = __webpack_public_path__ + "static/media/yellow.72315057.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/yellow.svg
// module id = 73
// module chunks = 0